export default __webpack_public_path__ + "static/Prihlaska_do_kurzu_Autoskola_Hron_sro_farebna-d28117d5a7fdb8286462322c158753b4.pdf";